import React, { FC } from 'react'
import styled, { css } from 'styled-components'
import logo from '../../assets/images/msc-logo.svg'

export interface ImageProps {
	aspectRatio?: [number, number] | number | undefined
	src?: string
	className?: string
	alt?: string
}

interface ImageWrapperProps {
	aspectRatio?: ImageProps['aspectRatio']
	src?: string
}

export const ImageWrapper = styled.div<ImageWrapperProps>(
	({ aspectRatio = [1, 1], src }) => css`
		position: relative;
		${Array.isArray(aspectRatio)
			? `padding-bottom: calc(100% / ${aspectRatio[0]} * ${aspectRatio[1]});`
			: `padding-bottom: calc(100% / ${aspectRatio});`}
		background: ${({ theme }) => !src && theme.accents.brandColor};
	`,
)

interface ImageElementProps {
	cover: boolean
}

export const ImageElement = styled.img<ImageElementProps>`
	position: absolute;
	top: 50%;
	left: 50%;
	width: ${(props) => (props.cover ? '100%' : '45%')};
	height: ${(props) => (props.cover ? '100%' : 'auto')};
	object-fit: ${(props) => props.cover && 'cover'};
	transform: translate(-50%, -50%);
`

// @TODO pass alt, height, width for metrics (check what is av from dato)
const Image: FC<ImageProps> = ({ src, alt, aspectRatio, className }) => (
	<ImageWrapper aspectRatio={aspectRatio} src={src} className={className}>
		<ImageElement src={src ? src : logo} alt={alt} cover={!!src} />
	</ImageWrapper>
)

export default styled(Image)``
